/**
 * CursorGlow — listens for mousemove inside its parent (must have
 * `position: relative` and the `.cursor-glow` class on the parent)
 * and writes `--cursor-x` / `--cursor-y` CSS vars used by the
 * `.cursor-glow::after` radial gradient.
 *
 * Pure CSS handles the visual; this just feeds the coordinates.
 * Respects prefers-reduced-motion: doesn't attach the listener at all.
 */
import { useEffect } from "react";

export function CursorGlowController() {
  useEffect(() => {
    if (
      typeof window === "undefined" ||
      (window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches)
    ) {
      return undefined;
    }

    const targets = Array.from(document.querySelectorAll(".cursor-glow"));
    if (targets.length === 0) return undefined;

    let raf = 0;
    let pendingX = 0;
    let pendingY = 0;
    let pendingEl = null;

    const apply = () => {
      if (pendingEl) {
        pendingEl.style.setProperty("--cursor-x", `${pendingX}px`);
        pendingEl.style.setProperty("--cursor-y", `${pendingY}px`);
      }
    };

    const handlers = targets.map((el) => {
      const onMove = (e) => {
        const rect = el.getBoundingClientRect();
        pendingX = e.clientX - rect.left;
        pendingY = e.clientY - rect.top;
        pendingEl = el;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(apply);
      };
      el.addEventListener("mousemove", onMove);
      return [el, onMove];
    });

    return () => {
      handlers.forEach(([el, onMove]) => el.removeEventListener("mousemove", onMove));
      cancelAnimationFrame(raf);
    };
  }, []);

  return null;
}
